// src/components/dashboard/HeaderDashboard.jsx
import React from 'react';
import {
    Box,
    Container,
    Flex,
    HStack,
    Image,
    Heading,
    Text,
    Badge,
    Button,
    Menu,
    MenuButton,
    MenuList,
    MenuItem,
    IconButton,
    Avatar,
    Tooltip,
} from '@chakra-ui/react';
import {
    FiMenu,
    FiUser,
    FiGrid,
    FiUpload,
    FiShare2,
    FiLogOut,
    FiPlus,
    FiBook,
    FiHome,
} from 'react-icons/fi';
import { useNavigate } from 'react-router-dom';
import logo from '../../assets/logo.png';
import { Link } from 'react-router-dom';


const HeaderDashboard = ({
    profile,
    user,
    showCredits = true,
    showBuyButton = true,
    onCheckoutOpen,
    onSignOut,
    onNavigate,
    currentPath = 'dashboard',
}) => {
    const navigate = useNavigate();

    // Pega o nome do usuário ou email como fallback
    const displayName = profile?.name || user?.email?.split('@')[0] || 'Usuário';

    const handleSignOut = async () => {
        if (onSignOut) {
            await onSignOut();
        }
    };

    const handleNavigate = (path) => {
        if (onNavigate) {
            onNavigate(path);
        } else {
            navigate(path);
        }
    };

    return (
        <Box as="header" bg="white" py={4} px={4} boxShadow="sm">
            <Container maxW="container.xl">
                <Flex justify="space-between" align="center">
                    {/* Logo e nome */}
                    <Link to="/dashboard" style={{ textDecoration: 'none' }}>
                        <HStack spacing={4} cursor="pointer">
                            <Image src={logo} alt="Draw Your Goods" height="40px" />
                            <Heading size="md" color="brand.primary" display={{ base: 'none', md: 'block' }}>
                                Draw Your Goods
                            </Heading>
                        </HStack>
                    </Link>


                    {/* Lado direito - informações e menu */}
                    <HStack spacing={4}>
                        {/* Nome do usuário */}
                        <HStack display={{ base: 'none', md: 'flex' }}>
                            <Avatar size="sm" name={displayName} src={profile?.photo_url} />
                            <Text fontWeight="medium" color="gray.700">
                                {displayName}
                            </Text>
                        </HStack>

                        {/* Créditos */}
                        {showCredits && (
                            <Box
                                py={1}
                                px={3}
                                bg="gray.100"
                                borderRadius="full"
                                display="flex"
                                alignItems="center"
                            >
                                <Text color="gray.700" fontWeight="medium" mr={2}>
                                    Créditos:
                                </Text>
                                <Badge colorScheme="green" fontSize="md" py={1} px={2} borderRadius="md">
                                    {profile?.creditos || 0}
                                </Badge>
                            </Box>
                        )}

                        {/* Botão de comprar créditos */}
                        {showBuyButton && onCheckoutOpen && (
                            <Button
                                colorScheme="blue"
                                bgGradient="linear(to-r, brand.primary, brand.secondary)"
                                color="white"
                                size="sm"
                                leftIcon={<FiPlus />}
                                onClick={onCheckoutOpen}
                                _hover={{
                                    transform: 'translateY(-2px)',
                                    boxShadow: 'md',
                                }}
                            >
                                Comprar créditos
                            </Button>
                        )}

                        {/* Menu */}
                        <Menu>
                            <MenuButton
                                as={IconButton}
                                icon={<FiMenu />}
                                variant="ghost"
                                color="gray.700"
                                aria-label="Menu"
                            />
                            <MenuList>
                                {/* Nome do usuário no mobile */}
                                <Box px={3} py={2} borderBottom="1px" borderColor="gray.200" display={{ base: 'block', md: 'none' }}>
                                    <HStack>
                                        <Avatar size="sm" name={displayName} src={profile?.photo_url} />
                                        <Text fontWeight="medium" color="gray.700">
                                            {displayName}
                                        </Text>
                                    </HStack>
                                </Box>

                                {currentPath === 'album' ? (
                                    // Menu para AlbumCreator
                                    <>
                                        <MenuItem
                                            icon={<FiHome />}
                                            onClick={() => handleNavigate('/dashboard')}
                                        >
                                            Voltar ao Dashboard
                                        </MenuItem>

                                        {/* 
                                        <MenuItem
                                            icon={<FiUser />}
                                            onClick={() => {
                                                if (onNavigate) {
                                                    onNavigate('profile');
                                                }
                                            }}
                                        >
                                            Meu perfil
                                        </MenuItem>
                                        */}

                                        <MenuItem
                                            icon={<FiLogOut />}
                                            onClick={handleSignOut}
                                        >
                                            Sair
                                        </MenuItem>
                                    </>
                                ) : (
                                    // Menu para Dashboard
                                    <>
                                        <MenuItem
                                            icon={<FiUser />}
                                            onClick={() => onNavigate?.('profile')}
                                        >
                                            Meu perfil
                                        </MenuItem>
                                        <MenuItem
                                            icon={<FiGrid />}
                                            onClick={() => onNavigate?.({ tab: 0 })}
                                        >
                                            Galeria
                                        </MenuItem>
                                        <MenuItem
                                            icon={<FiUpload />}
                                            onClick={() => onNavigate?.({ tab: 1 })}
                                        >
                                            Criar Desenho
                                        </MenuItem>
                                        <MenuItem
                                            icon={<FiShare2 />}
                                            onClick={() => onNavigate?.({ tab: 2 })}
                                        >
                                            Meu cupom
                                        </MenuItem>
                                        <MenuItem
                                            icon={<FiBook />}
                                            onClick={() => navigate('/album-creator')}
                                        >
                                            Criar Livro
                                        </MenuItem>
                                        <MenuItem
                                            icon={<FiLogOut />}
                                            onClick={handleSignOut}
                                        >
                                            Sair
                                        </MenuItem>
                                    </>
                                )}
                            </MenuList>
                        </Menu>
                    </HStack>
                </Flex>
            </Container>
        </Box>
    );
};

export default HeaderDashboard;